<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2020-06-14 16:36:44
 * @LastEditTime: 2021-03-03 10:39:29
 * @FilePath: \EmAtlas\src\views\Browser.vue
-->
<template>
    <div>
        <el-breadcrumb separator="/" style="padding: 15px;padding-top: 15px;padding-bottom: 0px">
            <el-breadcrumb-item :to="{ path: '/' }">RaacFold</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/browser' }">RaacView</el-breadcrumb-item>
        </el-breadcrumb>
        <hr style="margin: 12px 0 0 0 ">
        <multi-sequence-analysis></multi-sequence-analysis>
    </div>
</template>

<script>
    import MultiSequenceAnalysis from "../components/MultiSequenceAnalysis";

    export default {
        components: {
            MultiSequenceAnalysis
        },
        data (){
            return{
                winHeight: window.innerHeight - 91 + "px",
            }
        },
        name: "Search"
    }
</script>

<style scoped>

</style>
